/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateHandle.defs.js'
export * as $defs from './updateHandle.defs.js'
